import { Container, Section } from '@workos-inc/design-system';
import * as React from 'react';
import { Footer } from './footer';
const PageLayoutContext = React.createContext<PageLayoutRootProps['layout']>('centered');
interface PageLayoutRootProps {
  children?: React.ReactNode;
  layout: 'index' | 'sidebar' | 'centered';
}
const PageLayoutRoot = ({
  children,
  layout
}: PageLayoutRootProps) => <div className="PageLayoutRoot" data-sentry-component="PageLayoutRoot" data-sentry-source-file="page-layout.tsx">
    <div className={`PageLayoutInner ${layout}`} data-algolia-page-scope="">
      <PageLayoutContext.Provider value={layout} data-sentry-element="PageLayoutContext.Provider" data-sentry-source-file="page-layout.tsx">
        {children}
      </PageLayoutContext.Provider>
    </div>
    <Footer data-sentry-element="Footer" data-sentry-source-file="page-layout.tsx" />
  </div>;
PageLayoutRoot.displayName = 'PageLayoutRoot';
const PageLayoutNav = ({
  children
}: React.PropsWithChildren) => <div className="PageLayoutNav" data-sentry-component="PageLayoutNav" data-sentry-source-file="page-layout.tsx">{children}</div>;
PageLayoutNav.displayName = 'PageLayoutNav';
const PageLayoutContent = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const layout = React.useContext(PageLayoutContext);
  if (layout === 'index') {
    return <div className="PageLayoutContent index">
        <Section size={{
        initial: '1',
        sm: '2',
        md: '3',
        lg: '4'
      }}>
          <Container mx={{
          initial: '4',
          sm: '5',
          md: '6'
        }} size="4">
            {children}
          </Container>
        </Section>
      </div>;
  }
  if (layout === 'sidebar') {
    return <div className="PageLayoutContent sidebar">
        <Section gridColumnStart="2" minWidth="0" size={{
        initial: '1',
        sm: '2'
      }}>
          <Container mx={{
          initial: '4',
          sm: '5',
          md: '0'
        }} size={{
          initial: '4',
          sm: '2'
        }}>
            {children}
          </Container>
        </Section>
      </div>;
  }
  return <div className="PageLayoutContent centered" data-sentry-component="PageLayoutContent" data-sentry-source-file="page-layout.tsx">
      <Section size={{
      initial: '1',
      sm: '2'
    }} data-sentry-element="Section" data-sentry-source-file="page-layout.tsx">
        <Container mx={{
        initial: '4',
        sm: '5',
        md: '0'
      }} size={{
        initial: '4',
        sm: '2'
      }} data-sentry-element="Container" data-sentry-source-file="page-layout.tsx">
          {children}
        </Container>
      </Section>
    </div>;
};
export const PageLayout = {
  Root: PageLayoutRoot,
  Nav: PageLayoutNav,
  Content: PageLayoutContent
};